// extracted by mini-css-extract-plugin
module.exports = {"relative":"Layout_relative__2AdOI","sticky":"Layout_sticky__y_DEF","fixed":"Layout_fixed__1C1QC"};